export default "__VITE_ASSET__CDhWqtD1__"